var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFltb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2742 15.6316L11.2 27L8.4 27L11.9364 15.6316L4.4324 15.6316L2.1 19.8947L2.94507e-06 19.8947L1.4 13.5L3.50412e-06 7.10526L2.1 7.10526L4.4338 11.3684L11.9378 11.3684L8.4 -8.56743e-07L11.2 -7.34351e-07L18.2742 11.3684L25.9 11.3684C26.457 11.3684 26.9911 11.593 27.3849 11.9927C27.7788 12.3925 28 12.9347 28 13.5C28 14.0653 27.7787 14.6075 27.3849 15.0073C26.9911 15.407 26.457 15.6316 25.9 15.6316L18.2742 15.6316Z",
    fill: "#2866C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFltb);
export default __webpack_public_path__ + "static/media/fltb.c8bfeb1ceb6acec9393819675659d24d.svg";
export { ForwardRef as ReactComponent };